import React from 'react';

function CompletionScreen({ onBack }) {
  return (
    <div className="completion-screen">
      <h3>تمام اطلاعات با موفقیت ثبت شد</h3>
      <p className="completion-message">ما در اسرع وقت با شما تماس خواهیم گرفت!</p>
      <div className="completion-actions">
        <button type="button" onClick={onBack} className="submit-button">
          بازگشت به صفحه مدیریت املاک و آگهی‌ها
        </button>
      </div>
    </div>
  );
}

export default CompletionScreen;
